<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :footer="null"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    cancelText="关闭">
    <biz-businessinfo-form ref="realForm" @ok="submitCallback" @cancel="cancelCallback" :disabled="disableSubmit"></biz-businessinfo-form>
  </j-modal>
</template>

<script>

  import BizBusinessinfoForm from './BizBusinessinfoForm'
  export default {
    name: 'BizBusinessinfoModal',
    components: {
      BizBusinessinfoForm
    },
    data () {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add (flag) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(flag);
        })
      },
      copyAdd(record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.copyAdd(record);
        })
      },
      edit (record) {
        this.visible=true

        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);



        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      cancelCallback(){
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>